import axiosInstance from "./http/axios_instance"
const http = axiosInstance("/protected", null )

const getRecentRent = (postcode, summary_id, bedrooms, rerun) => http.get("/property_recent_rent/" + postcode + "/" + summary_id + "/" + bedrooms + "/" + rerun);

export default {
    getRecentRent
}